import React from "react";

const LoginFloatingInput = ({
  id,
  name,
  type = "text",
  label,
  value,
  onChange,
  error,
  autoComplete,
}) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const isPassword = type === "password";
  const resolvedType = isPassword && showPassword ? "text" : type;

  return (
    <div className={"form-group login-floating" + (isPassword ? " login-floating--password" : "")}>
      <input
        id={id}
        name={name}
        type={resolvedType}
        className={"form-control" + (error ? " is-invalid" : "")}
        placeholder=" "
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
      />
      <label htmlFor={id}>{label}</label>
      {isPassword && (
        <button
          type="button"
          className="login-floating-toggle"
          tabIndex={-1}
          onClick={() => setShowPassword((s) => !s)}
          aria-label={showPassword ? "Hide password" : "Show password"}
          title={showPassword ? "Hide password" : "Show password"}
        >
          <i className={"fa " + (showPassword ? "fa-eye-slash" : "fa-eye")} />
        </button>
      )}
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
};

export default LoginFloatingInput;
